Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbL10n = require('airbnb-l10n');

var _airbnbL10n2 = _interopRequireDefault(_airbnbL10n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// L10n may not be fully bootstrapped at the beginning of script loading
// causing false warnings during prop type check.
// Using closure ensure that the validator called is created at the same time of validation
// The object is also cached so we don’t call L10n many times
var getValidator = function getValidator() {
  return _propTypes2['default'].oneOf(_airbnbL10n2['default'].currencies());
};
var currency = function currency() {
  return getValidator().apply(undefined, arguments);
};
currency.isRequired = function () {
  var _getValidator;

  return (_getValidator = getValidator()).isRequired.apply(_getValidator, arguments);
};

exports['default'] = currency;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/currency.js
// module id = 447
// module chunks = 168707334958949